import Lang from '~/scripts/services/model/lang';

export default class Method {
	/**
	 * @param {any} [method]
	 */
	constructor(method = undefined) {
		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.kid = method?.kid;

		/** @type {boolean} */
		this.file = method?.file === 1;

		/** @type {string | undefined} */
		this.icon = method?.icon;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.isa = method?.isa;

		/** @type {any} */
		this.kjson = method?.kjson || null;

		this.lang = new Lang(method?.lang);

		/** @type {string | undefined} */
		this.name = method?.name;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.name_type_kid = method?.name_type_kid;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.type_kid = method?.type_kid;
	}
}
